(function () {
  var drawer = document.querySelector(".quick-product-drawer");
  if (!drawer) return;

  var overlay = drawer.querySelector("[data-quick-product-close]");
  var panel = drawer.querySelector(".quick-product-drawer__panel");
  var closeButton = drawer.querySelector(".quick-product-drawer__close");
  var galleryEl = drawer.querySelector("[data-quick-gallery]");
  var galleryWrapperEl = drawer.querySelector("[data-quick-gallery-wrapper]");
  var titleEl = drawer.querySelector("[data-quick-title]");
  var priceEl = drawer.querySelector("[data-quick-price]");
  var compareEl = drawer.querySelector("[data-quick-compare]");
  var badgeEl = drawer.querySelector("[data-quick-discount]");
  var productTagEl = drawer.querySelector("[data-quick-product-tag]");
  var materialValueEl = drawer.querySelector("[data-quick-material-value]");
  var sizeValueEl = drawer.querySelector("[data-quick-size-value]");
  var sizesEl = drawer.querySelector("[data-quick-sizes]");
  var soldOutEl = drawer.querySelector("[data-quick-soldout]");
  var qtyInput = drawer.querySelector("[data-quick-qty-input]");
  var addButton = drawer.querySelector("[data-quick-add-to-cart]");
  var buyButton = drawer.querySelector("[data-quick-buy-now]");

  var state = {
    product: null,
    variants: [],
    optionNames: [],
    sizeIndex: -1,
    colorIndex: -1,
    selectedVariant: null,
  };

  function isDesktop() {
    return window.matchMedia("(min-width: 1024px)").matches;
  }

  function openDrawer() {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("quick-product-drawer-open");
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("quick-product-drawer-open");
  }

  function formatMoney(cents) {
    if (
      window.MarmorisStorefrontCurrency &&
      typeof window.MarmorisStorefrontCurrency.formatMoneySync === "function"
    ) {
      return window.MarmorisStorefrontCurrency.formatMoneySync(cents);
    }

    var amount = typeof cents === "number" ? cents : parseFloat(cents || 0);
    if (isNaN(amount)) amount = 0;

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      var withCurrencyFormat =
        window.Shopify.money_with_currency_format || window.Shopify.money_format;
      if (withCurrencyFormat) {
        return window.Shopify.formatMoney(amount, withCurrencyFormat);
      }
    }

    var locale = document.documentElement.lang || "th-TH";
    var currency =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      "THB";

    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      currencyDisplay: "code",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount / 100);
  }

  function parseProductData(card) {
    var dataScript = card.querySelector(".quick-add-product-data");
    if (!dataScript) return null;
    try {
      return JSON.parse(dataScript.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function normalizeOptionName(optionName) {
    if (typeof optionName === "string") {
      return optionName.toLowerCase();
    }

    if (optionName && typeof optionName.name === "string") {
      return optionName.name.toLowerCase();
    }

    return String(optionName || "").toLowerCase();
  }

  function findSizeIndex(optionNames) {
    if (!Array.isArray(optionNames)) return -1;
    for (var i = 0; i < optionNames.length; i++) {
      var value = normalizeOptionName(optionNames[i]);
      if (
        value === "size" ||
        value === "shoe size" ||
        value === "ขนาด" ||
        value === "尺码" ||
        value === "尺寸" ||
        value === "サイズ" ||
        value === "靴のサイズ" ||
        value === "鞋码" ||
        value === "尺碼" ||
        value === "鞋碼" ||
        value === "신발 사이즈" ||
        value === "사이즈" ||
        value === "크기"
      ) {
        return i;
      }
    }
    return optionNames.length ? 0 : -1;
  }

  function findColorIndex(optionNames, sizeIndex) {
    if (!Array.isArray(optionNames) || !optionNames.length) return -1;

    for (var i = 0; i < optionNames.length; i++) {
      var value = normalizeOptionName(optionNames[i]);
      if (
        value === "color" ||
        value === "colour" ||
        value === "material & color" ||
        value === "material/color" ||
        value === "material and color" ||
        value === "สี" ||
        value === "颜色" ||
        value === "材质与颜色" ||
        value === "顏色" ||
        value === "材質與顏色" ||
        value === "色" ||
        value === "カラー" ||
        value === "素材と色" ||
        value === "색상" ||
        value === "색" ||
        value === "소재 및 색상"
      ) {
        return i;
      }
    }

    for (var j = 0; j < optionNames.length; j++) {
      if (j !== sizeIndex) return j;
    }

    return optionNames.length ? 0 : -1;
  }

  function getOption(variant, index) {
    if (!variant || index < 0) return "";
    if (
      Array.isArray(variant.options) &&
      variant.options[index] !== undefined
    ) {
      return variant.options[index];
    }
    return variant["option" + (index + 1)] || "";
  }

  function getSelectedOrFirstAvailable(variants, selectedId) {
    var id = parseInt(selectedId, 10);
    if (!isNaN(id)) {
      var matched = variants.find(function (variant) {
        return variant.id === id;
      });
      if (matched && matched.available) return matched;
    }
    var firstAvailable = variants.find(function (variant) {
      return variant.available;
    });
    return firstAvailable || variants[0] || null;
  }

  function getUniqueSizes() {
    var sizeMap = {};
    state.variants.forEach(function (variant) {
      var size = getOption(variant, state.sizeIndex);
      if (size) sizeMap[size] = true;
    });
    var sizes = Object.keys(sizeMap);
    var isNumeric = sizes.every(function (size) {
      return /^\d+(\.\d+)?$/.test(size);
    });
    if (isNumeric) {
      sizes.sort(function (a, b) {
        return parseFloat(a) - parseFloat(b);
      });
    } else {
      sizes.sort();
    }
    return sizes;
  }

  function variantForSize(sizeValue) {
    var currentColor = getOption(state.selectedVariant, state.colorIndex);
    return findVariant(currentColor, sizeValue) || findVariant(null, sizeValue);
  }

  function findVariant(colorValue, sizeValue) {
    return state.variants.find(function (variant) {
      var matchesColor =
        state.colorIndex < 0 ||
        colorValue === null ||
        getOption(variant, state.colorIndex) === colorValue;
      var matchesSize =
        state.sizeIndex < 0 ||
        sizeValue === null ||
        getOption(variant, state.sizeIndex) === sizeValue;
      return matchesColor && matchesSize;
    });
  }

  function isSoldOut(variant) {
    if (!variant) return false;
    if (variant.available === false) return true;
    if (variant.inventory_policy === "continue") return false;
    if (variant.inventory_management) {
      if (
        typeof variant.inventory_quantity === "number" &&
        variant.inventory_quantity <= 0
      ) {
        return true;
      }
    }
    return false;
  }

  function getQty() {
    var qty = parseInt(qtyInput ? qtyInput.value : "1", 10);
    if (isNaN(qty) || qty < 1) return 1;
    return qty;
  }

  function renderGallery(images) {
    var targetEl = galleryWrapperEl || galleryEl;
    if (!targetEl) return;
    targetEl.innerHTML = "";
    var list = Array.isArray(images) ? images : [];
    list.forEach(function (src) {
      var item = document.createElement("div");
      item.className = "swiper-slide quick-product-drawer__thumb";
      var img = document.createElement("img");
      img.src = src;
      img.alt = state.product ? state.product.title || "" : "";
      img.loading = "lazy";
      item.appendChild(img);
      targetEl.appendChild(item);
    });
  }

  function renderPrices() {
    if (!state.selectedVariant) return;
    if (priceEl) {
      priceEl.setAttribute("data-money-cents", state.selectedVariant.price || 0);
      priceEl.textContent = formatMoney(state.selectedVariant.price || 0);
    }

    var compareAt = state.selectedVariant.compare_at_price;
    var price = state.selectedVariant.price;
    if (compareAt && compareAt > price) {
      if (priceEl) {
        priceEl.classList.add("price-main");
      }
      if (compareEl) {
        compareEl.setAttribute("data-money-cents", compareAt);
        compareEl.textContent = formatMoney(compareAt);
        compareEl.style.display = "";
      }
      var discount = Math.round(((compareAt - price) * 100) / compareAt);
      if (badgeEl) {
        badgeEl.textContent = discount + "% discount";
        badgeEl.style.display = "inline-flex";
      }
    } else {
      if (priceEl) {
        priceEl.classList.remove("price-main");
      }
      if (compareEl) {
        compareEl.removeAttribute("data-money-cents");
        compareEl.textContent = "";
        compareEl.style.display = "none";
      }
      if (badgeEl) {
        badgeEl.textContent = "";
        badgeEl.style.display = "none";
      }
    }

    if (
      window.MarmorisStorefrontCurrency &&
      typeof window.MarmorisStorefrontCurrency.enhancePrices === "function"
    ) {
      window.MarmorisStorefrontCurrency.enhancePrices(drawer);
    }
  }

  function renderProductTag() {
    if (!productTagEl) return;

    var tag = state.product && state.product.product_specific_tag
      ? String(state.product.product_specific_tag)
      : "";

    productTagEl.textContent = tag;
    productTagEl.style.display = tag ? "inline-flex" : "none";
  }

  function renderSizes() {
    if (!sizesEl) return;
    sizesEl.innerHTML = "";

    var currentColor = getOption(state.selectedVariant, state.colorIndex);
    var sizes = getUniqueSizes();
    sizes.forEach(function (sizeValue) {
      var matchForColor = findVariant(currentColor, sizeValue);
      var matchAny = findVariant(null, sizeValue);
      var button = document.createElement("button");
      button.type = "button";
      button.className = "quick-product-drawer__size";
      button.textContent = sizeValue;
      button.setAttribute("data-size-value", sizeValue);

      if (!matchForColor && !matchAny) {
        button.disabled = true;
        button.classList.add("is-unavailable");
        button.classList.add("sold-out");
      } else if (matchForColor && isSoldOut(matchForColor)) {
        button.disabled = true;
        button.classList.add("is-unavailable");
        button.classList.add("sold-out");
      } else if (!matchForColor && matchAny && isSoldOut(matchAny)) {
        button.disabled = true;
        button.classList.add("is-unavailable");
        button.classList.add("sold-out");
      }

      if (getOption(state.selectedVariant, state.sizeIndex) === sizeValue) {
        button.classList.add("is-active");
      }

      sizesEl.appendChild(button);
    });
  }

  function syncStateToUI() {
    if (!state.selectedVariant) return;

    if (materialValueEl) {
      materialValueEl.textContent =
        getOption(state.selectedVariant, state.colorIndex) || "-";
    }

    if (sizeValueEl) {
      sizeValueEl.textContent =
        getOption(state.selectedVariant, state.sizeIndex) || "-";
    }

    renderProductTag();
    renderPrices();
    renderSizes();

    var available = !!state.selectedVariant.available;
    if (soldOutEl) soldOutEl.style.display = available ? "none" : "block";
    if (addButton) addButton.disabled = !available;
    if (buyButton) buyButton.disabled = !available;
  }

  function setLoading(isLoading) {
    var available = !!(
      state.selectedVariant && state.selectedVariant.available
    );
    if (addButton) addButton.disabled = isLoading || !available;
    if (buyButton) buyButton.disabled = isLoading || !available;
    drawer.classList.toggle("is-loading", !!isLoading);
  }

  function addItem(variantId, quantity) {
    var localizePath = window.localizeStorefrontPath || function (path) { return path; };
    return fetch(localizePath("/cart/add.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    }).then(function (res) {
      if (!res.ok) {
        throw new Error("Unable to add item");
      }
      return res.json();
    });
  }

  function openForProduct(productData) {
    if (
      !productData ||
      !Array.isArray(productData.variants) ||
      !productData.variants.length
    )
      return;

    state.product = productData;
    state.variants = productData.variants;
    state.optionNames = Array.isArray(productData.options)
      ? productData.options
      : [];
    state.sizeIndex = findSizeIndex(state.optionNames);
    state.colorIndex = findColorIndex(state.optionNames, state.sizeIndex);
    state.selectedVariant = getSelectedOrFirstAvailable(
      state.variants,
      productData.selected_variant_id,
    );

    if (titleEl) {
      titleEl.textContent = productData.title || "";
      titleEl.setAttribute("href", productData.url || "#");
    }

    if (qtyInput) qtyInput.value = "1";
    renderGallery(productData.images || []);
    syncStateToUI();
    openDrawer();
  }

  if (overlay) {
    overlay.addEventListener("click", closeDrawer);
  }
  if (closeButton) {
    closeButton.addEventListener("click", closeDrawer);
  }

  if (panel) {
    panel.addEventListener("click", function (event) {
      var target = event.target;
      if (!target) return;

      var sizeButton = target.closest(".quick-product-drawer__size");
      if (sizeButton && !sizeButton.disabled) {
        var sizeValue = sizeButton.getAttribute("data-size-value");
        var nextVariant = variantForSize(sizeValue);
        if (nextVariant) {
          state.selectedVariant = nextVariant;
          syncStateToUI();
        }
        return;
      }

      var qtyButton = target.closest(".quick-product-drawer__qty-btn");
      if (qtyButton && qtyInput) {
        var currentQty = getQty();
        if (qtyButton.getAttribute("data-action") === "increase") {
          qtyInput.value = currentQty + 1;
        } else {
          qtyInput.value = Math.max(1, currentQty - 1);
        }
      }
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener("change", function () {
      qtyInput.value = String(getQty());
    });
  }

  if (addButton) {
    addButton.addEventListener("click", function () {
      if (!state.selectedVariant || !state.selectedVariant.available) return;
      setLoading(true);
      addItem(state.selectedVariant.id, getQty())
        .then(function () {
          closeDrawer();
          if (
            window.CartDrawer &&
            typeof window.CartDrawer.open === "function"
          ) {
            window.CartDrawer.open();
          }
        })
        .catch(function () {})
        .finally(function () {
          setLoading(false);
        });
    });
  }

  if (buyButton) {
    buyButton.addEventListener("click", function () {
      if (!state.selectedVariant || !state.selectedVariant.available) return;
      setLoading(true);
      addItem(state.selectedVariant.id, getQty())
        .then(function () {
          var localizePath = window.localizeStorefrontPath || function (path) { return path; };
          window.location.href = localizePath("/checkout");
        })
        .catch(function () {
          setLoading(false);
        });
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && drawer.classList.contains("is-open")) {
      closeDrawer();
    }
  });

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target) return;

    var trigger = target.closest("[data-quick-add-trigger]");
    if (!trigger) return;
    if (!isDesktop()) return;
    if (trigger.classList.contains("is-disabled")) return;

    var card = trigger.closest(".product-card");
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();
    openForProduct(parseProductData(card));
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    var target = event.target;
    if (!target || !target.matches("[data-quick-add-trigger]")) return;
    if (!isDesktop()) return;
    if (target.classList.contains("is-disabled")) return;

    var card = target.closest(".product-card");
    if (!card) return;

    event.preventDefault();
    openForProduct(parseProductData(card));
  });
})();
